export enum CommunicationChannel {
  LMS = "LMS",
  Email = "Email",
  SchoolWebsite = "School website",
  DirectMail = "Direct mail",
  SocialMedia = "Social media",
  BulletinBoards = "Bulletin boards",
  MorningAnnouncements = "Morning announcements",
  Other = "Other",
}
